import type { WebChannelSeoConfig } from '@repo/api/web/models'

/**
 * Загружает per-channel SEO-настройки витрины (`GET seo/config`) один раз на
 * SSR — дальше они едут на клиент в payload (useState).
 *
 * Намеренно обычный $fetch, а не типизированный gateway из DI: контейнер при
 * резолве тянет цепочку сервисов (вплоть до UserService), которые в
 * конструкторе зовут nuxt-композаблы. Внутри асинхронного продолжения
 * (после await) nuxt-контекст уже потерян → «composable outside setup», и
 * конфиг молча не грузился. Здесь всё нужное берётся синхронно в setup,
 * а $fetch контекста не требует.
 *
 * dependsOn: host-loader — хост канала пишет он.
 *
 * Ошибка API не должна ронять страницу: конфиг остаётся null, мета падает на
 * авто-генерацию (поведение Итерации 1).
 */
export default defineNuxtPlugin({
  name: 'seo-config-loader:plugin',
  dependsOn: ['host-loader:plugin'],

  async setup() {
    const state = useSeoConfig()
    if (state.value) return

    const runtimeConfig = useRuntimeConfig()
    const appConfig = useAppConfig()

    const apiBase
      = (runtimeConfig.API_BASE_URL as string)
        || (runtimeConfig.public.API_BASE_URL as string)
    const host = appConfig.host

    if (!apiBase || !host) return

    try {
      state.value = await $fetch<WebChannelSeoConfig>(
        `${apiBase}/showcases/v1/${host}/seo/config`,
      )
    } catch (error) {
      console.warn('[seo] не удалось загрузить seo/config:', error)
    }
  },
})
